import React from 'react';
import P from 'prop-types';
import './styles.css';
import { Button } from '../Button';
import { FormataValor } from '../../utils/utils';
//import FlipNumbers from 'react-flip-numbers';

export const DetalhesRodape = ({
  total,
  isCompleted,
  onClick,
  onClickDiminui,
  onClickSoma,
  quantidade,
  disabled = false,
}) => {
  return (
    <div className="footer-sticky">
      <div
        className="container_quantidade"
        style={
          {
            //borderColor: disabled ? '#f2f2f2' : 'gainsboro',
            // background: disabled ? '#f2f2f2' : 'white',
            // height: '56px',
          }
        }
      >
        <Button className="btnQuantidade dec" icon="remove" onClick={onClickDiminui} disabled={disabled} />
        <div style={{ marginTop: '17px' }}>
          <h1 style={{ color: disabled ? 'gainsboro' : 'black', textAlign: 'center', marginTop: '-10px' }}>
            {quantidade}
          </h1>
        </div>
        <Button className="btnQuantidade inc" icon="add" onClick={onClickSoma} disabled={disabled} />
      </div>
      <div style={{ height: '56px' }}>
        <Button
          className="btnDetalhes btnGradient disable"
          text="Adicionar"
          textAlign="left"
          text2={FormataValor(total)}
          text2Align="right"
          disabled={isCompleted ? false : true}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

DetalhesRodape.propTypes = {
  total: P.number,
  isCompleted: P.bool,
  onClick: P.func,
  onClickDiminui: P.func,
  onClickSoma: P.func,
  quantidade: P.number,
  disabled: P.bool,
};
